module.exports = __webpack_public_path__ + "img/sendcoinicon.05ff33b0.svg";